import { L10n } from "@syncfusion/ej2-base";
import i18n from "../i18n";

export const setupSyncfusionLocalisation = () => {
  // Create Syncfusion localization object using i18n translations
  const localizationData = {
    [i18n.language]: {
      'grid': {
        'EmptyRecord': i18n.t('syncfusion.grid.EmptyRecord'),
        'GroupDropArea': i18n.t('syncfusion.grid.GroupDropArea'),
        'UnGroup': i18n.t('syncfusion.grid.UnGroup'),
        'EmptyDataSourceError': i18n.t('syncfusion.grid.EmptyDataSourceError'),
        'Item': i18n.t('syncfusion.grid.Item'),
        'Items': i18n.t('syncfusion.grid.Items')
      },
      'pager': {
        'currentPageInfo': i18n.t('syncfusion.pager.currentPageInfo'),
        'totalItemsInfo': i18n.t('syncfusion.pager.totalItemsInfo'),
        'firstPageTooltip': i18n.t('syncfusion.pager.firstPageTooltip'),
        'lastPageTooltip': i18n.t('syncfusion.pager.lastPageTooltip'),
        'nextPageTooltip': i18n.t('syncfusion.pager.nextPageTooltip'),
        'previousPageTooltip': i18n.t('syncfusion.pager.previousPageTooltip'),
        'nextPagerTooltip': i18n.t('syncfusion.pager.nextPagerTooltip'),
        'previousPagerTooltip': i18n.t('syncfusion.pager.previousPagerTooltip'),
        'pagerDropDown': i18n.t('syncfusion.pager.pagerDropDown'),
        'pagerAllDropDown': i18n.t('syncfusion.pager.pagerAllDropDown'),
        'All': i18n.t('syncfusion.pager.All'),
        'totalItemInfo': i18n.t('syncfusion.pager.totalItemInfo'),
        'Container': i18n.t('syncfusion.pager.Container'),
        'Information': i18n.t('syncfusion.pager.Information'),
        'Page': i18n.t('syncfusion.pager.Page'),
        'Of': i18n.t('syncfusion.pager.Of'),
        'Pages': i18n.t('syncfusion.pager.Pages')
      },
      'toolbar': {
        'FilterRows': i18n.t('syncfusion.toolbar.FilterRows'),
        'DisableFiltering': i18n.t('syncfusion.toolbar.DisableFiltering'),
        'EnableSelectionMode': i18n.t('syncfusion.toolbar.EnableSelectionMode'),
        'DisableSelectionMode': i18n.t('syncfusion.toolbar.DisableSelectionMode'),
        'Search': i18n.t('syncfusion.toolbar.Search'),
        'PdfExport': i18n.t('syncfusion.toolbar.PdfExport'),
        'ExcelExport': i18n.t('syncfusion.toolbar.ExcelExport'),
        'Add': i18n.t('syncfusion.toolbar.Add'),
        'Delete': i18n.t('syncfusion.toolbar.Delete'),
        'Edit': i18n.t('syncfusion.toolbar.Edit'),
        'Update': i18n.t('syncfusion.toolbar.Update'),
        'Cancel': i18n.t('syncfusion.toolbar.Cancel'),
        'Save': i18n.t('syncfusion.toolbar.Save'),
        'Print': i18n.t('syncfusion.toolbar.Print'),
        'Csvexport': i18n.t('syncfusion.toolbar.Csvexport')
      }
    }
  };
  
  // Load the localization data into Syncfusion
  L10n.load(localizationData);
};